import * as Types from '../../../../../types.generated';

import { gql } from '@apollo/client';
import { JumpToEmployeeFragmentDoc, JumpToTrainingResourceFragmentDoc, JumpToOrgPremiumContentConfigFragmentDoc, JumpToCourseFragmentDoc, JumpToLocationFragmentDoc, JumpToRoleFragmentDoc, JumpToLocationGroupFragmentDoc, JumpToRoleGroupFragmentDoc } from './useAllJumpToItems.generated';
import { TranslationSetFragmentDoc, CoverImageFragmentDoc } from '../../../../../fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RecentlyViewedEmployeesQueryVariables = Types.Exact<{
  openedStartDate: Types.Scalars['DateTime']['input'];
}>;


export type RecentlyViewedEmployeesQuery = { __typename?: 'Query', Employees: { __typename?: 'Employees', objects: Array<{ __typename?: 'Employee', openedAt?: string | null, id: number, name: string, email?: string | null, phoneNumber?: string | null, userType: Types.UserType, deactivatedAt?: string | null, locations: Array<{ __typename?: 'Location', id: number, name: string }>, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null }> } };

export type RecentlyViewedLibraryItemsQueryVariables = Types.Exact<{
  input: Types.AdminLibraryInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type RecentlyViewedLibraryItemsQuery = { __typename?: 'Query', LibraryItems: { __typename?: 'LibraryItems', objects: Array<{ __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, searchHeadline?: string | null, openedAt?: string | null, module?: { __typename?: 'Module', id: number } | null, course?: { __typename?: 'Course', id: number } | null, trainingResource?: { __typename?: 'TrainingResource', id: string, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, media?: { __typename?: 'Media', id: number, unoptimizedUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, original: string } | null } | null } | null } | null, skill?: { __typename?: 'Skill', id: number } | null, scormCourse?: { __typename?: 'SCORMCourse', id: string } | null, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, orgPremiumContentConfig?: { __typename?: 'OrgPremiumContentConfig', id: number, setupStep: Types.PremiumContentSetupStep, catalogConfig: { __typename?: 'PremiumContentConfig', id: number, catalogModule?: { __typename?: 'CatalogModule', id: string, module: { __typename?: 'Module', id: number, libraryItem: { __typename?: 'LibraryItem', id: string, searchHeadline?: string | null, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } } } | null } } | null, orgSharpConfig?: { __typename?: 'OrgSharpConfig', id: string } | null }> } };

export type RecentlyViewedCoursesQueryVariables = Types.Exact<{
  openedStartDate: Types.Scalars['DateTime']['input'];
}>;


export type RecentlyViewedCoursesQuery = { __typename?: 'Query', CourseLibrary: Array<{ __typename?: 'Course', id: number, libraryItem: { __typename?: 'LibraryItem', id: string, openedAt?: string | null, searchHeadline?: string | null, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null } }> };

export type RecentlyViewedTrainingResourcesQueryVariables = Types.Exact<{
  openedStartDate: Types.Scalars['DateTime']['input'];
}>;


export type RecentlyViewedTrainingResourcesQuery = { __typename?: 'Query', TrainingResources: Array<{ __typename?: 'TrainingResource', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, openedAt?: string | null }, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, media?: { __typename?: 'Media', id: number, unoptimizedUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, original: string } | null } | null } | null }> };

export type RecentlyViewedLocationsQueryVariables = Types.Exact<{
  openedStartDate: Types.Scalars['DateTime']['input'];
}>;


export type RecentlyViewedLocationsQuery = { __typename?: 'Query', Locations: { __typename?: 'Locations', objects: Array<{ __typename?: 'Location', openedAt?: string | null, id: number, name: string }> } };

export type RecentlyViewedRolesQueryVariables = Types.Exact<{
  openedStartDate: Types.Scalars['DateTime']['input'];
}>;


export type RecentlyViewedRolesQuery = { __typename?: 'Query', Roles: { __typename?: 'Roles', objects: Array<{ __typename?: 'Role', openedAt?: string | null, id: number, name: string }> } };

export type RecentlyViewedLocationGroupsQueryVariables = Types.Exact<{
  openedStartDate: Types.Scalars['DateTime']['input'];
}>;


export type RecentlyViewedLocationGroupsQuery = { __typename?: 'Query', LocationGroups: { __typename?: 'LocationGroups', objects: Array<{ __typename?: 'LocationGroup', openedAt?: string | null, id: string, name: string, type: Types.LocationGroupType, locationMemberships: Array<{ __typename?: 'LocationGroupMembership', id: string }> }> } };

export type RecentlyViewedRoleGroupsQueryVariables = Types.Exact<{
  openedStartDate: Types.Scalars['DateTime']['input'];
}>;


export type RecentlyViewedRoleGroupsQuery = { __typename?: 'Query', RoleGroups: { __typename?: 'RoleGroups', objects: Array<{ __typename?: 'RoleGroup', openedAt?: string | null, id: string, name: string, roleMemberships: Array<{ __typename?: 'RoleGroupMembership', id: string }> }> } };


export const RecentlyViewedEmployeesDocument = gql`
    query RecentlyViewedEmployees($openedStartDate: DateTime!) {
  Employees: AdminEmployees(openedStartDate: $openedStartDate) {
    objects {
      ...JumpToEmployee
      openedAt
    }
  }
}
    ${JumpToEmployeeFragmentDoc}`;

/**
 * __useRecentlyViewedEmployeesQuery__
 *
 * To run a query within a React component, call `useRecentlyViewedEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentlyViewedEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentlyViewedEmployeesQuery({
 *   variables: {
 *      openedStartDate: // value for 'openedStartDate'
 *   },
 * });
 */
export function useRecentlyViewedEmployeesQuery(baseOptions: Apollo.QueryHookOptions<RecentlyViewedEmployeesQuery, RecentlyViewedEmployeesQueryVariables> & ({ variables: RecentlyViewedEmployeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentlyViewedEmployeesQuery, RecentlyViewedEmployeesQueryVariables>(RecentlyViewedEmployeesDocument, options);
      }
export function useRecentlyViewedEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentlyViewedEmployeesQuery, RecentlyViewedEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentlyViewedEmployeesQuery, RecentlyViewedEmployeesQueryVariables>(RecentlyViewedEmployeesDocument, options);
        }
export type RecentlyViewedEmployeesQueryHookResult = ReturnType<typeof useRecentlyViewedEmployeesQuery>;
export type RecentlyViewedEmployeesLazyQueryHookResult = ReturnType<typeof useRecentlyViewedEmployeesLazyQuery>;
export type RecentlyViewedEmployeesQueryResult = Apollo.QueryResult<RecentlyViewedEmployeesQuery, RecentlyViewedEmployeesQueryVariables>;
export const RecentlyViewedLibraryItemsDocument = gql`
    query RecentlyViewedLibraryItems($input: AdminLibraryInput!, $pagination: PaginationInput) {
  LibraryItems: AdminLibrary(input: $input, pagination: $pagination) {
    objects {
      id
      type
      module {
        id
      }
      course {
        id
      }
      trainingResource {
        id
      }
      skill {
        id
      }
      scormCourse {
        id
      }
      name {
        ...TranslationSet
      }
      searchHeadline
      coverImage {
        ...CoverImage
      }
      trainingResource {
        ...JumpToTrainingResource
      }
      orgPremiumContentConfig {
        ...JumpToOrgPremiumContentConfig
      }
      orgSharpConfig {
        id
      }
      openedAt
    }
  }
}
    ${TranslationSetFragmentDoc}
${CoverImageFragmentDoc}
${JumpToTrainingResourceFragmentDoc}
${JumpToOrgPremiumContentConfigFragmentDoc}`;

/**
 * __useRecentlyViewedLibraryItemsQuery__
 *
 * To run a query within a React component, call `useRecentlyViewedLibraryItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentlyViewedLibraryItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentlyViewedLibraryItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useRecentlyViewedLibraryItemsQuery(baseOptions: Apollo.QueryHookOptions<RecentlyViewedLibraryItemsQuery, RecentlyViewedLibraryItemsQueryVariables> & ({ variables: RecentlyViewedLibraryItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentlyViewedLibraryItemsQuery, RecentlyViewedLibraryItemsQueryVariables>(RecentlyViewedLibraryItemsDocument, options);
      }
export function useRecentlyViewedLibraryItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentlyViewedLibraryItemsQuery, RecentlyViewedLibraryItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentlyViewedLibraryItemsQuery, RecentlyViewedLibraryItemsQueryVariables>(RecentlyViewedLibraryItemsDocument, options);
        }
export type RecentlyViewedLibraryItemsQueryHookResult = ReturnType<typeof useRecentlyViewedLibraryItemsQuery>;
export type RecentlyViewedLibraryItemsLazyQueryHookResult = ReturnType<typeof useRecentlyViewedLibraryItemsLazyQuery>;
export type RecentlyViewedLibraryItemsQueryResult = Apollo.QueryResult<RecentlyViewedLibraryItemsQuery, RecentlyViewedLibraryItemsQueryVariables>;
export const RecentlyViewedCoursesDocument = gql`
    query RecentlyViewedCourses($openedStartDate: DateTime!) {
  CourseLibrary: AdminCourseLibrary(openedStartDate: $openedStartDate) {
    ...JumpToCourse
    libraryItem {
      id
      openedAt
    }
  }
}
    ${JumpToCourseFragmentDoc}`;

/**
 * __useRecentlyViewedCoursesQuery__
 *
 * To run a query within a React component, call `useRecentlyViewedCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentlyViewedCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentlyViewedCoursesQuery({
 *   variables: {
 *      openedStartDate: // value for 'openedStartDate'
 *   },
 * });
 */
export function useRecentlyViewedCoursesQuery(baseOptions: Apollo.QueryHookOptions<RecentlyViewedCoursesQuery, RecentlyViewedCoursesQueryVariables> & ({ variables: RecentlyViewedCoursesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentlyViewedCoursesQuery, RecentlyViewedCoursesQueryVariables>(RecentlyViewedCoursesDocument, options);
      }
export function useRecentlyViewedCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentlyViewedCoursesQuery, RecentlyViewedCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentlyViewedCoursesQuery, RecentlyViewedCoursesQueryVariables>(RecentlyViewedCoursesDocument, options);
        }
export type RecentlyViewedCoursesQueryHookResult = ReturnType<typeof useRecentlyViewedCoursesQuery>;
export type RecentlyViewedCoursesLazyQueryHookResult = ReturnType<typeof useRecentlyViewedCoursesLazyQuery>;
export type RecentlyViewedCoursesQueryResult = Apollo.QueryResult<RecentlyViewedCoursesQuery, RecentlyViewedCoursesQueryVariables>;
export const RecentlyViewedTrainingResourcesDocument = gql`
    query RecentlyViewedTrainingResources($openedStartDate: DateTime!) {
  TrainingResources: AdminTrainingResources(openedStartDate: $openedStartDate) {
    ...JumpToTrainingResource
    libraryItem {
      id
      openedAt
    }
  }
}
    ${JumpToTrainingResourceFragmentDoc}`;

/**
 * __useRecentlyViewedTrainingResourcesQuery__
 *
 * To run a query within a React component, call `useRecentlyViewedTrainingResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentlyViewedTrainingResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentlyViewedTrainingResourcesQuery({
 *   variables: {
 *      openedStartDate: // value for 'openedStartDate'
 *   },
 * });
 */
export function useRecentlyViewedTrainingResourcesQuery(baseOptions: Apollo.QueryHookOptions<RecentlyViewedTrainingResourcesQuery, RecentlyViewedTrainingResourcesQueryVariables> & ({ variables: RecentlyViewedTrainingResourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentlyViewedTrainingResourcesQuery, RecentlyViewedTrainingResourcesQueryVariables>(RecentlyViewedTrainingResourcesDocument, options);
      }
export function useRecentlyViewedTrainingResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentlyViewedTrainingResourcesQuery, RecentlyViewedTrainingResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentlyViewedTrainingResourcesQuery, RecentlyViewedTrainingResourcesQueryVariables>(RecentlyViewedTrainingResourcesDocument, options);
        }
export type RecentlyViewedTrainingResourcesQueryHookResult = ReturnType<typeof useRecentlyViewedTrainingResourcesQuery>;
export type RecentlyViewedTrainingResourcesLazyQueryHookResult = ReturnType<typeof useRecentlyViewedTrainingResourcesLazyQuery>;
export type RecentlyViewedTrainingResourcesQueryResult = Apollo.QueryResult<RecentlyViewedTrainingResourcesQuery, RecentlyViewedTrainingResourcesQueryVariables>;
export const RecentlyViewedLocationsDocument = gql`
    query RecentlyViewedLocations($openedStartDate: DateTime!) {
  Locations(input: {openedStartDate: $openedStartDate}) {
    objects {
      ...JumpToLocation
      openedAt
    }
  }
}
    ${JumpToLocationFragmentDoc}`;

/**
 * __useRecentlyViewedLocationsQuery__
 *
 * To run a query within a React component, call `useRecentlyViewedLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentlyViewedLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentlyViewedLocationsQuery({
 *   variables: {
 *      openedStartDate: // value for 'openedStartDate'
 *   },
 * });
 */
export function useRecentlyViewedLocationsQuery(baseOptions: Apollo.QueryHookOptions<RecentlyViewedLocationsQuery, RecentlyViewedLocationsQueryVariables> & ({ variables: RecentlyViewedLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentlyViewedLocationsQuery, RecentlyViewedLocationsQueryVariables>(RecentlyViewedLocationsDocument, options);
      }
export function useRecentlyViewedLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentlyViewedLocationsQuery, RecentlyViewedLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentlyViewedLocationsQuery, RecentlyViewedLocationsQueryVariables>(RecentlyViewedLocationsDocument, options);
        }
export type RecentlyViewedLocationsQueryHookResult = ReturnType<typeof useRecentlyViewedLocationsQuery>;
export type RecentlyViewedLocationsLazyQueryHookResult = ReturnType<typeof useRecentlyViewedLocationsLazyQuery>;
export type RecentlyViewedLocationsQueryResult = Apollo.QueryResult<RecentlyViewedLocationsQuery, RecentlyViewedLocationsQueryVariables>;
export const RecentlyViewedRolesDocument = gql`
    query RecentlyViewedRoles($openedStartDate: DateTime!) {
  Roles(input: {openedStartDate: $openedStartDate}) {
    objects {
      ...JumpToRole
      openedAt
    }
  }
}
    ${JumpToRoleFragmentDoc}`;

/**
 * __useRecentlyViewedRolesQuery__
 *
 * To run a query within a React component, call `useRecentlyViewedRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentlyViewedRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentlyViewedRolesQuery({
 *   variables: {
 *      openedStartDate: // value for 'openedStartDate'
 *   },
 * });
 */
export function useRecentlyViewedRolesQuery(baseOptions: Apollo.QueryHookOptions<RecentlyViewedRolesQuery, RecentlyViewedRolesQueryVariables> & ({ variables: RecentlyViewedRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentlyViewedRolesQuery, RecentlyViewedRolesQueryVariables>(RecentlyViewedRolesDocument, options);
      }
export function useRecentlyViewedRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentlyViewedRolesQuery, RecentlyViewedRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentlyViewedRolesQuery, RecentlyViewedRolesQueryVariables>(RecentlyViewedRolesDocument, options);
        }
export type RecentlyViewedRolesQueryHookResult = ReturnType<typeof useRecentlyViewedRolesQuery>;
export type RecentlyViewedRolesLazyQueryHookResult = ReturnType<typeof useRecentlyViewedRolesLazyQuery>;
export type RecentlyViewedRolesQueryResult = Apollo.QueryResult<RecentlyViewedRolesQuery, RecentlyViewedRolesQueryVariables>;
export const RecentlyViewedLocationGroupsDocument = gql`
    query RecentlyViewedLocationGroups($openedStartDate: DateTime!) {
  LocationGroups(input: {openedStartDate: $openedStartDate}) {
    objects {
      ...JumpToLocationGroup
      openedAt
    }
  }
}
    ${JumpToLocationGroupFragmentDoc}`;

/**
 * __useRecentlyViewedLocationGroupsQuery__
 *
 * To run a query within a React component, call `useRecentlyViewedLocationGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentlyViewedLocationGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentlyViewedLocationGroupsQuery({
 *   variables: {
 *      openedStartDate: // value for 'openedStartDate'
 *   },
 * });
 */
export function useRecentlyViewedLocationGroupsQuery(baseOptions: Apollo.QueryHookOptions<RecentlyViewedLocationGroupsQuery, RecentlyViewedLocationGroupsQueryVariables> & ({ variables: RecentlyViewedLocationGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentlyViewedLocationGroupsQuery, RecentlyViewedLocationGroupsQueryVariables>(RecentlyViewedLocationGroupsDocument, options);
      }
export function useRecentlyViewedLocationGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentlyViewedLocationGroupsQuery, RecentlyViewedLocationGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentlyViewedLocationGroupsQuery, RecentlyViewedLocationGroupsQueryVariables>(RecentlyViewedLocationGroupsDocument, options);
        }
export type RecentlyViewedLocationGroupsQueryHookResult = ReturnType<typeof useRecentlyViewedLocationGroupsQuery>;
export type RecentlyViewedLocationGroupsLazyQueryHookResult = ReturnType<typeof useRecentlyViewedLocationGroupsLazyQuery>;
export type RecentlyViewedLocationGroupsQueryResult = Apollo.QueryResult<RecentlyViewedLocationGroupsQuery, RecentlyViewedLocationGroupsQueryVariables>;
export const RecentlyViewedRoleGroupsDocument = gql`
    query RecentlyViewedRoleGroups($openedStartDate: DateTime!) {
  RoleGroups(input: {openedStartDate: $openedStartDate}) {
    objects {
      ...JumpToRoleGroup
      openedAt
    }
  }
}
    ${JumpToRoleGroupFragmentDoc}`;

/**
 * __useRecentlyViewedRoleGroupsQuery__
 *
 * To run a query within a React component, call `useRecentlyViewedRoleGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentlyViewedRoleGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentlyViewedRoleGroupsQuery({
 *   variables: {
 *      openedStartDate: // value for 'openedStartDate'
 *   },
 * });
 */
export function useRecentlyViewedRoleGroupsQuery(baseOptions: Apollo.QueryHookOptions<RecentlyViewedRoleGroupsQuery, RecentlyViewedRoleGroupsQueryVariables> & ({ variables: RecentlyViewedRoleGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentlyViewedRoleGroupsQuery, RecentlyViewedRoleGroupsQueryVariables>(RecentlyViewedRoleGroupsDocument, options);
      }
export function useRecentlyViewedRoleGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentlyViewedRoleGroupsQuery, RecentlyViewedRoleGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentlyViewedRoleGroupsQuery, RecentlyViewedRoleGroupsQueryVariables>(RecentlyViewedRoleGroupsDocument, options);
        }
export type RecentlyViewedRoleGroupsQueryHookResult = ReturnType<typeof useRecentlyViewedRoleGroupsQuery>;
export type RecentlyViewedRoleGroupsLazyQueryHookResult = ReturnType<typeof useRecentlyViewedRoleGroupsLazyQuery>;
export type RecentlyViewedRoleGroupsQueryResult = Apollo.QueryResult<RecentlyViewedRoleGroupsQuery, RecentlyViewedRoleGroupsQueryVariables>;